module.exports = __webpack_public_path__ + "img/1527088245.05741ca3.jpg";